export default function CronExpression({ cronExpression }: { cronExpression: string }) {
  return (
    <span className="text-gray dark:text-neutral-600 text-sm bg-borderColor-100 dark:bg-neutral-100 p-1">{cronExpression}</span>
  );
};
